import { ronin } from '@0xtorch/core'
import { ronin as viemRonin } from 'viem/chains'
import { type Client, createClient } from '../../client'
import { type Explorer, createBlockscout } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createRoninChain = ({
  explorerProxyUrl: proxyUrl,
}: {
  explorerProxyUrl?: string
}) =>
  createRoninChainCustom({
    client: createClient({
      chain: viemRonin,
      httpRpcs: roninHttpRpcs,
    }),
    explorer: createBlockscout({
      name: 'Ronin Mainnet explorer',
      baseUrl: 'https://explorer.roninchain.com/',
      apiBaseUrl: 'https://explorer.roninchain.com/api',
      proxyUrl,
    }),
  })

type CreateRoninChainParameters = {
  client: Client
  explorer: Explorer
}

export const createRoninChainCustom = ({
  client,
  explorer,
}: CreateRoninChainParameters): Chain => ({
  id: 2020,
  network: 'ronin',
  name: 'Ronin',
  nativeToken: {
    name: 'Ronin',
    symbol: 'RON',
    decimals: 18,
    currency: ronin,
  },
  wrappedTokenAddresses: new Set([
    '0xe514d9deb7966c8be0ca922de8a064264ea6bcd4',
  ]),
  explorer,
  client,
  blockTime: 3000,
  coingeckoId: 'ronin',
  defillamaId: 'ronin',
})

export const roninHttpRpcs: HttpRpc[] = [
  {
    url: 'https://api.roninchain.com/rpc',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 200n,
  },
  // Not archiving receipts
  // {
  //   url: 'https://ronin.lgns.net/rpc',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 20_000n,
  // },
  // Endpoint is not working
  // {
  //   url: 'https://api-gateway.skymavis.com/rpc?apikey=9aqYLBbxSC6LROynQJBvKkEIsioqwHmr',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 500n,
  // },
  // 古い tx の receipt を返せる endpoint (api.roninchain.com / drpc は null を返す)
  {
    url: 'https://ronin.rpc.thirdweb.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1000n,
  },
  {
    url: 'https://ronin.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://ronin-mainnet.gateway.tatum.io',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const roninWebsocketRpcUrls: readonly string[] = []
